import './PolicyStyles.css'; // Ensure path is correct
import { exportToWord } from '../utils/exportToWord'; // Import your export function

const ComplianceAndRegulatoryPolicy = ({
  clientName,
  clientAddress,
  effectiveDate,
  companyNumber,
  complianceOfficerContact,
  regulatoryBodyContact,
}) => {
  // Export handler
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Compliance_and_Regulatory_Policy.docx");
  };

  return (
    <div className="policy-container">
      <h3 className="policy-title">Accident & Incident Management Policy</h3>
      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> { companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>
      
      <h4 className="section-title">Purpose</h4>
      <p className="section-content">
        This policy establishes the framework to ensure the company meets all statutory and regulatory requirements relevant to its operations. It promotes a culture of compliance, accountability, and continual improvement.
      </p>

      <h4 className="section-title">Scope</h4>
      <p className="section-content">
        Applies to all employees, contractors, and third-party service providers. Covers all aspects of legal compliance, including transport regulations, health & safety, environmental laws, and financial controls.
      </p>

      <h4 className="section-title">Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> Must understand and comply with all relevant laws and company policies, reporting any breaches or concerns promptly.</p>
      <p className="section-content"><strong>Compliance Officer:</strong> Oversees regulatory compliance efforts, provides training, monitors compliance status, and reports to senior management.</p>
      <p className="section-content"><strong>Managers:</strong> Ensure their teams adhere to policies and support compliance activities within their departments.</p>

      <h4 className="section-title">Compliance Activities</h4>
      <ul>
        <li>Regular audits and inspections to verify adherence to policies and legal requirements.</li>
        <li>Training and awareness programs for all staff on compliance and regulatory updates.</li>
        <li>Documentation and record-keeping to demonstrate compliance.</li>
        <li>Prompt investigation and remediation of any non-compliance issues.</li>
      </ul>

      <h4 className="section-title">Reporting and Monitoring</h4>
      <p className="section-content">
        Any breaches or suspected breaches of compliance must be reported immediately to the Compliance Officer or through designated reporting channels.
      </p>
      <p className="section-content">
        The company will monitor compliance through regular reporting, audits, and performance metrics, ensuring continuous improvement.
      </p>

      <h4 className="section-title">External Regulatory Bodies</h4>
      <p className="section-content">
        The company cooperates fully with all relevant regulatory authorities. Contact details for the key regulatory bodies are provided below:
      </p>
      <ul>
        <li><strong>Compliance Officer:</strong> {complianceOfficerContact || "[Insert Contact Number]"}</li>
        <li><strong>Regulatory Body:</strong> {regulatoryBodyContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Record Keeping</h4>
      <p className="section-content">
        All compliance documentation, audit records, and incident reports will be retained according to legal and company requirements to ensure traceability.
      </p>

      <h4 className="section-title">Conclusion</h4>
      <p className="section-content">
        Adhering to this policy ensures the company operates legally, ethically, and responsibly. Every employee has a role in maintaining compliance and fostering a culture of integrity.
      </p>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I have read, understood, and agree to comply with the Compliance & Regulatory Policy.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is hereby in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      {/* Export to Word Button */}
      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-500 text-white px-6 py-2 rounded-lg hover:bg-green-600 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default ComplianceAndRegulatoryPolicy;
